import {
  RECEIVED_AUTH_USER,
  CLEAR_AUTH_USER
} from '../modules/auth/actions'
import { firestore } from '../utils/firebase'
import { receivedOnboardings } from '../modules/onboardings/actions'

export default store => next => action => {
  switch (action.type) {
    case RECEIVED_AUTH_USER:
      next(action)

      if (action.authUser) {
        startSyncingOnboardings(store, action.authUser.id)
      }

      break

    case CLEAR_AUTH_USER:
      next(action)
      stopSyncingOnboardings()
      break

    default:
      next(action)
  }
}

let unsubscribe

export function startSyncingOnboardings (store, userId) {
  unsubscribe = firestore
    .collection('onboardings')
    .where(`users.${userId}`, '>', {})
    .onSnapshot(async onboardingQuery => {
      const onboardings = []

      for (let i = 0; i < onboardingQuery.docs.length; i++) {
        const doc = onboardingQuery.docs[i]

        let onboarding = doc.data()

        if (onboarding.status === 'canceled') return

        const propertyDoc = await firestore
          .collection('properties_for_review')
          .doc(onboarding.propertyId)
          .get()

        if (!propertyDoc.exists) return

        const userIds = Object.keys(onboarding.users)

        await Promise.all(userIds.map(async userId => {
          const userDoc = await firestore
            .collection('users')
            .doc(userId)
            .get()

          if (userDoc.exists) {
            onboarding.users[userId].user = userDoc.data()
          }
        }))

        onboarding.property = propertyDoc.data()
        onboardings.push(onboarding)
      }

      store.dispatch(receivedOnboardings(onboardings))
    })
}

export function stopSyncingOnboardings () {
  unsubscribe && unsubscribe()
}
